import { render, staticRenderFns } from "./EmployeeDataForm.vue?vue&type=template&id=44248635&"
import script from "./EmployeeDataForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports